import { useState } from 'react';
import { BrokerAgreementSummary } from '../../../../../../queries/brokerAgreementQueries';
import { PrimaryEntityField } from './components/PrimaryEntityField';
import { UpdateEntityButton } from './components/UpdateEntityButton';
import '../../../../../../styles/_inputAlignedActions.scss';

/**
 * Picks the agreement's primary entity from its borrower entities; "Update Entity" saves it straight away (not with the
 * loan). The choice starts from the agreement's current primary entity.
 */
export const PrimaryEntityUpdate = ({ summary }: { summary: BrokerAgreementSummary }) => {
    const [primaryEntityId, set_primaryEntityId] = useState<number | null>(summary.entityId ?? null);

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ flex: '1 1 0', minWidth: 0 }}>
                <PrimaryEntityField
                    value={primaryEntityId}
                    onChange={set_primaryEntityId}
                    entities={summary.borrowerEntities}
                />
            </div>
            <div className='borrowerSelectorInputAlignedActions'>
                <UpdateEntityButton
                    summary={summary}
                    primaryEntityId={primaryEntityId}
                />
            </div>
        </div>
    );
};
